import { useMutation } from '@tanstack/react-query'
import { supabase } from '../../api'

const updatePassword = async (password: string, userId?: string) => {
  const { data, error } = await supabase
    .functions
    .invoke('updatePassword', { body: { password, userId } })

  if (error) {
    throw new Error(error.message)
  }

  return data
}

export default function useUpdatePasswordByUserId(password: string, userId: string) {
  return useMutation(() => updatePassword(password, userId), {
    onSuccess: async (data) => data,
  })
}
